import { render, staticRenderFns } from "./trackers-tab.vue?vue&type=template&id=837e2dc8"
import script from "./trackers-tab.vue?vue&type=script&lang=js"
export * from "./trackers-tab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports